/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { useTranslation } from "react-i18next";
import { MultipleContentScroll } from "../multiple-content-scroll";
import "./index.less";
export const MultiplePageContentBlock = ({
  imgUrl,
  alt,
  content,
  position = "back",
  aside = null,
}) => {
  return (
    <div className={`multiplePage-content ${position}`}>
      <div className="text-box">{content}</div>
      {aside || (
        <div className="img-box">
          <img src={imgUrl} alt={alt} />
        </div>
      )}
    </div>
  );
};

export const MultiplePageContent = () => {
  const { t } = useTranslation();
  const cardOneContent = {
    aside: <MultipleContentScroll />,
    content: (
      <div>
        <h3 className="headline">
          {t("learn.mfaPage.features.blockOne.title")}
        </h3>
        <div className="paragraph">
          {t("learn.mfaPage.features.blockOne.descript1")}
        </div>
        <div className="paragraph">
          {t("learn.mfaPage.features.blockOne.descript2")}
        </div>
      </div>
    ),
  };
  const cardTwoContent = {
    imgUrl: "//files.authing.co/authing-website/mfa-protect-img-v2.png",
    position: "front",
    alt: "多因素认证和双因素认证",
    content: (
      <div>
        <h3 className="headline">
          {t("learn.mfaPage.features.blockTwo.title")}
        </h3>
        <div className="paragraph">
          {t("learn.mfaPage.features.blockTwo.descript1")}
        </div>
        <div className="paragraph">
          {t("learn.mfaPage.features.blockTwo.descript2")}
        </div>
      </div>
    ),
  };
  const cardThreeContent = {
    imgUrl: t("learn.mfaPage.features.blockThree.imgUrl"),
    position: "back",
    alt: "动态口令多因素认证",
    content: (
      <div>
        <h3 className="headline">
          {t("learn.mfaPage.features.blockThree.title")}
        </h3>
        <div className="paragraph">
          {t("learn.mfaPage.features.blockThree.descript")}
        </div>
      </div>
    ),
  };
  return (
    <div className="multiple-content-features">
      <MultiplePageContentBlock {...cardOneContent} />
      <MultiplePageContentBlock {...cardTwoContent} />
      <MultiplePageContentBlock {...cardThreeContent} />
    </div>
  );
};
